
import React from "react";
import ReactDOM from "react-dom";


// Controladores

// Controladores
import ControleModo from './ControleModo'
import ConstrutorGame from './Construtor'
import Alert from "./../ViewComponentsJogo/SubViewComponentsJogo/Alert";

//Balanceamento Game Design Balanceamento: Constantes 
const basePalavra = 1000
const baseTempo  = 20
const baseDica  = 50

export default class ControleJogo extends React.Component {

    constructor(props) {
        super(props)
        // fluxo inicial MODO
        this.ControleModo = new ControleModo()
        this.modo = 0
        this.state = {
            focus: 0
        }

    }

    manageModel(modo){
        this.modo = modo
        switch (modo) {
            case 1:

                this.ControleModo.curiosidades()

                break;
            case 2:
                this.ControleModo.usodasplantas()

                break;
            case 3:
                this.ControleModo.nomepopular()

                break;

            default:
                break;
        }

    }

    manageLevel(fase){
        this.ControleModo.setFase(fase)
    }

    init() {
        this.Construtor = new ConstrutorGame(this.ControleModo)
        console.log("Contrutor Final:::::::::::::::");
        console.log(this.Construtor)
        console.log("Contrutor Final:::::::::::::::");
        this.timerConte =0
        let arr = []
        for (let index = 0; index < this.Construtor.tabuleiro.palavras.length; index++) {
            arr.push(Array(this.Construtor.tabuleiro.palavras[index].length).fill(null));

        }

        // Variaveis Dinamicas
        this.state = {
            pontos: 0,
            tempo : { seconds: 0 , minutes: 0 },
            focus: 0,
            statusBoard: Array(this.Construtor.linhas * this.Construtor.colunas).fill(null),
            tips: this.ControleModo.tips,
            hitWord: Array(this.Construtor.quantPalavras).fill(false),
            statusWords: arr,
            Tips: Array(this.Construtor.quantPalavras).fill(false),

        }


    }

    // Manage of words

    next() {
        let lista = document.getElementById("lista-posicao")
        let total = lista.scrollHeight / 10
        let limite = this.Construtor.quantPalavras + 1
        do {
            console.log(limite);
            this.state.focus = this.state.focus === this.Construtor.principal.length - 1 ? 0 : this.state.focus + 1;
            limite--

        } while(this.state.hitWord[this.state.focus] & limite > 0)



        lista.scrollTop = total * (this.state.focus - 1)
    }

    prev() {
        let lista = document.getElementById("lista-posicao")
        let total = lista.scrollHeight / 10
        let limite = this.Construtor.quantPalavras +1

        do {
            console.log(limite);

            this.state.focus = this.state.focus === 0 ? this.Construtor.principal.length - 1 : this.state.focus - 1;
            limite--

        } while(this.state.hitWord[this.state.focus] & limite > 0)

        lista.scrollTop = total * (this.state.focus - 1)
    }

    selectFocus(index) {
        this.state.focus = index;
        let lista = document.getElementById("lista-posicao")
        let total = lista.scrollHeight/10
        lista.scrollTop = total*(this.state.focus-1) 
    }

    // Manage of tips

    useTip() {
        if(!this.state.Tips[this.state.focus]){
            if (this.state.tips)
                this.state.Tips[this.state.focus] = true
            this.state.tips = this.state.tips === 0 ? 0 : this.state.tips - 1;
            this.perdePonto(baseDica)
        }
        
    }


    //Manage of Keyboard letter

    deleteLetter(index, vinculo) {
        if(this.state.hitWord[index] !== true){

        
            console.log(this.Construtor.tabuleiro);
            console.log(this.state);
            
            for(let i in vinculo){
                if(this.Construtor.tabuleiro.vinculo[vinculo[i]].length > 1){

                    

                    let palavra1 = this.Construtor.tabuleiro.vinculo[vinculo[i]][0]
                    let palavra2 = this.Construtor.tabuleiro.vinculo[vinculo[i]][1]

                    if(this.state.hitWord[palavra1] === false && this.state.hitWord[palavra2] === false){
                        this.state.statusBoard[vinculo[i]] = null
                        let posi1 = this.Construtor.tabuleiro.posicoes[palavra1].indexOf(vinculo[i])
                        let posi2 = this.Construtor.tabuleiro.posicoes[palavra2].indexOf(vinculo[i])
                        this.state.statusWords[palavra1][posi1] = null
                        this.state.statusWords[palavra2][posi2] = null
                    }
                        
                }
                else{
                    let palavra = this.Construtor.tabuleiro.vinculo[vinculo[i]][0]
                    let posi = this.Construtor.tabuleiro.posicoes[palavra].indexOf(vinculo[i])
                    this.state.statusBoard[vinculo[i]] = null

                    this.state.statusWords[palavra][posi] = null

                }


            }
        }
    }

    selectLetter(vinculo, posi, letter) {

        if(this.Construtor.tabuleiro.vinculo[vinculo].length > 1){
            let palavra1 = this.Construtor.tabuleiro.vinculo[vinculo][0]
            let palavra2 = this.Construtor.tabuleiro.vinculo[vinculo][1]
            let posi1 = this.Construtor.tabuleiro.posicoes[palavra1].indexOf(vinculo)
            let posi2 = this.Construtor.tabuleiro.posicoes[palavra2].indexOf(vinculo)
        
            if(!this.state.hitWord[palavra1] & !this.state.hitWord[palavra2]){
                this.state.statusWords[palavra1][posi1] = letter
                this.state.statusWords[palavra2][posi2] = letter
                this.state.statusBoard[vinculo] = letter
                this.hitWord()
            }
        }else
            if(!this.state.hitWord[this.state.focus]){
            this.state.statusBoard[vinculo] = letter
            this.state.statusWords[this.state.focus][posi] = letter
            this.hitWord()
            }
           
    }



    // Game Rules

    perdePonto(pontos){
        this.state.pontos -= pontos
    }

    ganhaPonto(pontos){
        this.state.pontos += pontos
    }

    updateProgressoTempo(tempo){
        if(tempo.minutes > this.timerConte){
            this.timerConte += 1
            this.perdePonto(baseTempo)
        }

        this.state.tempo = tempo
    }
    //Words

    hitWord() {
        let teste = true;
        for (let index = 0; index < this.state.statusWords[this.state.focus].length; index++) {
            const status = this.state.statusWords[this.state.focus][index];
            const gabarito = this.Construtor.principal[this.state.focus].letras[index];
            if (status !== gabarito) {
                teste = false
                break
            }
        }

        

        this.state.hitWord[this.state.focus] = teste
        if(teste){
            console.log("ganha", basePalavra);
            console.log("tempo", this.state.tempo);
            this.ganhaPonto(basePalavra)
            this.renderAlert(this.Construtor.principal[this.state.focus].Resposta);
        }
    }

    renderAlert(palavra) {
        const element = <Alert palavra={palavra}/>;
        
        ReactDOM.render(
          element,
          document.getElementById("notificacao"),
          function () {
              
            document.getElementById("myAlert").classList.add("d-none")
            document.getElementById("myAlert").classList.remove("d-none")
            document.getElementById("myAlert").classList.replace("close", "show")
            document.getElementById("closeAlert").addEventListener("click", function () {
                    document.getElementById("myAlert").classList.replace("show", "close")
                }, false);
            setTimeout(() =>{
                document.getElementById("myAlert").classList.replace("show", "close")
            
            }, 3000);
            setTimeout(() =>{
                document.getElementById("myAlert").classList.add("d-none")
            
            }, 4500);
          }
        );
      }




}